import * as actionTypes from './actionTypes';
import * as actions from './index';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';

// Clip

const updateMetadataClipStart = () => {
    return {
        type: actionTypes.UPDATE_METADATA_CLIP_START
    };
};


const updateMetadataClipSuccess = () => {
    return {
        type: actionTypes.UPDATE_METADATA_CLIP_SUCCESS
    };
};


const updateMetadataClipFail = (error) => {
    return {
        type: actionTypes.UPDATE_METADATA_CLIP_FAIL,
        error: error
    };
};

// Project

const updateMetadataProjectStart = () => {
    return {
        type: actionTypes.UPDATE_METADATA_PROJECT_START
    };
};

const updateMetadataProjectSuccess = () => {
    return {
        type: actionTypes.UPDATE_METADATA_PROJECT_SUCCESS
    };
};

const updateMetadataProjectFail = (error) => {
    return {
        type: actionTypes.UPDATE_METADATA_PROJECT_FAIL,
        error: error
    };
};

// Distribution

const updateMetadataDistributionStart = () => {
    return {
        type: actionTypes.UPDATE_METADATA_DISTRIBUTION_START
    };
};

const updateMetadataDistributionSuccess = () => {
    return {
        type: actionTypes.UPDATE_METADATA_DISTRIBUTION_SUCCESS
    };
};

const updateMetadataDistributionFail = (error) => {
    return {
        type: actionTypes.UPDATE_METADATA_DISTRIBUTION_FAIL,
        error: error
    };
};

// Room

const updateMetadataRoomStart = () => {
    return {
        type: actionTypes.UPDATE_METADATA_ROOM_START
    };
};

const updateMetadataRoomSuccess = () => {
    return {
        type: actionTypes.UPDATE_METADATA_ROOM_SUCCESS
    };
};

const updateMetadataRoomFail = (error) => {
    return {
        type: actionTypes.UPDATE_METADATA_ROOM_FAIL,
        error: error
    };
};

// Config

const loadMetadataConfigStart = () => {
    return {
        type: actionTypes.LOAD_METADATA_CONFIG_START
    };
};

const loadMetadataConfigSuccess = (config) => {
    return {
        type: actionTypes.LOAD_METADATA_CONFIG_SUCCESS,
        config: config
    };
};

const loadMetadataConfigFail = (error) => {
    return {
        type: actionTypes.LOAD_METADATA_CONFIG_FAIL,
        error: error
    };
};

export const resetMetadataConditional = () => {
    return dispatch => {
        dispatch({ type: actionTypes.METADATA_CONDITIONAL_RESET });
    }
};

export const loadMetadataConfig = (local = true) => {
    return dispatch => {
        if (local) {
            console.log("LOAD LOCAL METADATA CONFIG");
            dispatch(loadMetadataConfigStart());
            import(`${process.env.REACT_APP_APPID}/config/MetadataConfig`).then((module) => {
                dispatch(loadMetadataConfigSuccess(module));
            }).catch((res) => {
                dispatch(loadMetadataConfigFail(res.message));
            });
        } else {
            console.log("LOAD EXTERNAL METADATA CONFIG");

            // TODO
            // remove and implement correct process to load config from server

            dispatch(loadMetadataConfigStart());
            import(`${process.env.REACT_APP_APPID}/config/MetadataConfig`).then((module) => {
                dispatch(loadMetadataConfigSuccess(module));
            }).catch((res) => {
                dispatch(loadMetadataConfigFail(res.message));
            });
        }
    }
};

export const loadSoapApiDef = () => {
    return dispatch => {
        dispatch({ type: actionTypes.LOAD_SOAP_API_DEF_START });
        window.flow.getSoapapidef().then((apiDef) => {
            dispatch({ type: actionTypes.LOAD_SOAP_API_DEF_SUCCESS, apiDef: apiDef });
        }).catch((res) => {
            console.log(res);
            dispatch({ type: actionTypes.LOAD_SOAP_API_DEF_FAIL });
        });
    }
}

export const saveMetadataConfig = (user, config, type) => {
    return dispatch => {
        let field = "";

        switch (type) {
            case Metadata.OBJECT_TYPE_PROJECT:
                field = "metadata_project";
                break;
            case Metadata.OBJECT_TYPE_CLIP:
            default:
                field = "metadata_clip";
                break;
        }

        dispatch({ type: actionTypes.SAVE_METADATA_CONFIG_START });
        window.flow.grantingEditUser(user.groupid, user.id, [
            { 'name': field, 'value': config }
        ], true).then((res) => {
            console.log("saveMetadataConfigSuccess", res);
            dispatch({ type: actionTypes.SAVE_METADATA_CONFIG_SUCCESS });
            dispatch({ type: actionTypes.UPDATE_METADATA_CONFIG, config: JSON.parse(config), field: type });
        }).catch(res => {
            dispatch({ type: actionTypes.SAVE_METADATA_CONFIG_FAIL });
            console.log("saveMetadataConfigFail");
        });
    }
}

export const updateMetadata4Upload = (type, id, metadata) => {
    return dispatch => {
        switch (type) {
            case Metadata.OBJECT_TYPE_CLIP:
                window.flow.editClip(id, metadata).then((clip) => {
                    if (clip && clip.mediafiles && clip.mediafiles.elements) {
                        dispatch({ type: actionTypes.UPLOAD_UPDATE_METADATA, payload: { mediafiles: clip.mediafiles.elements } });
                        //console.log("LAMTEST clip.mediafiles.elements", clip.mediafiles.elements);
                    }
                }).catch((res) => {
                    console.log(res);
                });
                break;
            default:
                break;
        }
    }
};

export const updateMetadata = (type, id, metadata, reloads/*, reload = true*/) => {
    return dispatch => {
        switch (type) {
            case Metadata.OBJECT_TYPE_PROJECT:
                console.log("UPDATE PROJECT");
                dispatch(updateMetadataProjectStart());
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editProject(id, metadata).then((project) => {
                    console.log("SUCCESS");
                    console.log(project);
					dispatch({ type: actionTypes.PROJECT_UPDATE_RECEIVED, project: project});
                    dispatch(updateMetadataProjectSuccess());
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    // reload projects
                    dispatch(actions.getProjectTree());
                    dispatch(actions.getProjects());
                    dispatch(actions.getDeletedProjects());

                    //dispatch({ type: actionTypes.PROJECT_UPDATE_RECEIVED, project: project });
                }).catch((res) => {
                    console.log(res);
                    dispatch(updateMetadataProjectFail(res.message));
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            case Metadata.OBJECT_TYPE_DISTRIBUTION:
                console.log("UPDATE DISTRIBUTION");
                dispatch(updateMetadataDistributionStart());
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editDistproject(id, metadata).then((res) => {
                    console.log("SUCCESS");
                    dispatch(updateMetadataDistributionSuccess());
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    // reload distributions
                    dispatch(actions.getDistributionByDist());
                    dispatch(actions.getDistributionTree());

                    //dispatch({ type: actionTypes.PROJECT_UPDATE_RECEIVED, project: project});
                }).catch((res) => {
                    console.log(res);
                    dispatch(updateMetadataDistributionFail(res.message));
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
			 case Metadata.OBJECT_TYPE_NEWSROOM:
                console.log("UPDATE NEWSROOM");
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editNewsroomproject(id, metadata).then((res) => {
                    console.log("SUCCESS");
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    // reload newsrooms
                    dispatch(actions.getNewsroomTree());
                }).catch((res) => {
                    console.log(res);
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            case Metadata.OBJECT_TYPE_ROOM:
                console.log("UPDATE ROOM");
                dispatch(updateMetadataRoomStart());
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editShowroom(id, metadata).then((room) => {
                    console.log("SUCCESS");
                    console.log(room);
                    dispatch({ type: actionTypes.ROOM_UPDATE_RECEIVED, room: room });
                    dispatch(updateMetadataRoomSuccess());
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    // reload rooms
                    dispatch(actions.getRooms());
                    dispatch(actions.getDeletedRooms());

                }).catch((res) => {
                    console.log(res);
                    dispatch(updateMetadataRoomFail(res.message));
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            case Metadata.OBJECT_TYPE_CLIP:
                console.log("UPDATE CLIP");
                dispatch(updateMetadataClipStart());
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editClip(id, metadata).then((clip) => {
                    console.log("SUCCESS", clip);
                    if (clip.hasOwnProperty('success')) {
                        console.log('FAIL CONDITIONAL');
                        if (!clip.success) {
                            dispatch({ type: actionTypes.METADATA_CONDITIONAL_FAIL, msg: clip.msg, fields: clip.data.fields });
                            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                        }
                    } else {
                        dispatch(updateMetadataClipSuccess());
                        dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    }
					
					console.log(id);
					let ids = id;
					// make string and split to array to find value
					if(!Array.isArray(ids)) {
						ids = (ids + "").split(',');
					}
					
					console.log(ids);
					
					if(ids.length > 1) {
						dispatch(actions.getCliplistByIds(ids));
					} else {
						dispatch(actions.getClipById(ids[0]));
					}
					
                    // reload clips
					/*ids.forEach((clipId) => {
						dispatch(actions.getClipById(clipId));
					});*/

                    if (reloads) {
                        dispatch(actions.reloadComponent(reloads.components, reloads.id));
                    }

                    //dispatch({ type: actionTypes.CLIP_UPDATE_RECEIVED, clip: clip });
                }).catch((res) => {
                    console.log(res);
                    dispatch(updateMetadataClipFail(res.message));
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            default:
                break;
        }

    }
};

export const reloadComponent = (reloads, id) => {
    return dispatch => {
        if (reloads.length) {
            reloads.forEach(component => {
                if (component === Metadata.OBJECT_TYPE_PROJECT && id) {
                    dispatch(actions.getClipsForClipList(Metadata.OBJECT_TYPE_PROJECT, id));
                }
				if (component === Metadata.OBJECT_TYPE_SERIES) {
                    dispatch(actions.getSeriesTree());
                }
            });
        }
    }
};

export const addMemberToProject = (id, member) => {
    return ((dispatch) => {
		dispatch({ type: actionTypes.ADD_MEMBER_PROJECT_START });
        dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
        window.flow.projectAddMember(id, member).then((project) => {
            dispatch({ type: actionTypes.ADD_MEMBER_PROJECT_SUCCESS });
            dispatch({ type: actionTypes.PROJECT_UPDATE_RECEIVED, project: project});
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
        }).catch((res) => {
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
			dispatch({ type: actionTypes.ADD_MEMBER_PROJECT_FAIL, error: res.message });
        });
    });
}


export const delMemberFromProject = (projectId, memberId) => {
    return (dispatch => {
		dispatch({ type: actionTypes.DELETE_MEMBER_PROJECT_START });
        dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
        window.flow.projectDelMember(projectId, memberId).then(project => {
			dispatch({ type: actionTypes.DELETE_MEMBER_PROJECT_SUCCESS });
			dispatch({ type: actionTypes.PROJECT_UPDATE_RECEIVED, project: project});
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
        }).catch(res => {
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
			dispatch({ type: actionTypes.DELETE_MEMBER_PROJECT_FAIL, error: res.message });
        })
    })
}
